<form [formGroup]="form" role="form">
    <div class="modal-body">
        <div class="row">
            <div class="form-group col">
                <label for="note">{{ 'common.note' | translate }}</label>
                <textarea
                        id="note"
                        name="note"
                        class="form-control"
                        formControlName="note"
                        rows="5">
                          </textarea>
                <div *ngIf="noteRequired">
                    <p style="color: red;">{{'base.field_required' | translate}}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col">
                <label>{{ 'common.notify_customer' | translate }}</label>
                    <button (click)="onNotify()"
                            [title]="'common.notify' | translate"
                            class="action primary-action m-0">
                        <em *ngIf="notify" class="fas fa-toggle-on"></em>
                        <em *ngIf="!notify" class="fas fa-toggle-off"></em>
                    </button>
                <app-email-form [hidden]="!notify"></app-email-form>
            </div>
        </div>
    </div>
</form>
